module.exports = __webpack_public_path__ + "img/payment-primary.2b9f3479.svg";